module.exports = __webpack_public_path__ + "static/media/logo_white.30627d5c.png";